import Http from '@/api/http.js'

export default {

  index(filter) {
    return Http.get(`/client_portfolios`, {params: filter})
  },
  create(client_portfolio){
    return Http.post(`/client_portfolios`, {
      client_portfolio
    })
  },
  update(client_portfolio){
    return Http.put(`/client_portfolios/${client_portfolio.id}`, {
      client_portfolio
    });
  },
  show(id) {
    return Http.get(`/client_portfolios/${id}`);
  },
  transfer_clients(params){
    return Http.put(`/client_portfolios/transfer_clients`, {
      ...params
    });
  },
}
